import Vue from 'vue';
import Vuex from 'vuex';
import contentful from '../services/contentful-service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isPageLoading: true,
    pages: [],
    isColumnsLoading: true,
    content: [],
  },
  mutations: {
    setLoadingPage(state) {
      state.isPageLoading = true;
    },
    unsetLoadingPage(state) {
      state.isPageLoading = false;
    },
    setLoadingColumns(state) {
      state.isColumnsLoading = true;
    },
    unsetLoadingColumns(state) {
      state.isColumnsLoading = false;
    },
    addPages(state, pages) {
      state.pages = pages;
    },
    addColumns(state, columns) {
      state.columns = columns;
    },
  },
  actions: {
    async getPages({ commit }) {
      commit('setLoadingPage');
      const pages = await contentful.getPages();
      commit('addPages', pages);
      commit('unsetLoadingPage');
    },
    async getColumns({ commit }) {
      commit('setLoadingColumns');
      const columns = await contentful.getColumns();
      commit('addColumns', columns);
      commit('unsetLoadingColumns');
    },
  },
  modules: {
  },
});
